<template>
  <div class="avatar-module">
      <div class="avatar-container-box d-flex flex-column justify-content-center align-items-center mx-auto" @click="getAvatarImage">
        <div ref="profile_box" id="profile_box" class="profile-pic" :style="{'background-image': preAvatar === '' ? 'url(' + require('../../../assets/img/profile/image.jpg') + ')' : `url(https://kishoto.ir/dtr/approid/img/${preAvatar})`,'background-size': 'contain'}"></div>
          <p class="mt-4">برای تغییر تصویر کلیک کنید</p>
          <input ref="fileUpload" style="display: none" type="file" accept="image/*" @change="onFilePicked">
      </div>

      <div class="background-image"></div>
  </div>
</template>

<script>


import store from "@/store";

//import avatariamge from "~@/assets/img/profile/image.jpg";

export default {
  data() {
    return {
      preAvatar: null,
      avatarImage:null,
      defaultimage : '../../../assets/img/profile/image.jpg'
    };
  },
  components: {

  },
  created() {
    this.getProfile();
  },
  methods: {
    async getProfile() {
      let fd = new FormData();
      fd.append("token", store.state.login.loginTempToken);
      const response = await this.$ApiServiceLayer.post("get_profile", fd);

    if(response.status_code === 200) {

        this.preAvatar = response.avatar;

      }else if(response.status_code === 500){
        this.$toast.open({
          message: 'شما نیاز به ورود مجدد به برنامه دارید',
          type: 'error',
        });
      }else{
        this.$toast.open({
          message: 'شما نیاز به ورود مجدد به برنامه دارید',
          type: 'error',
        });
      }
    },
    async updateAvatar() {
      let fd = new FormData();

      fd.append("token", store.state.login.loginTempToken);
      fd.append("file",this.avatarImage);
      fd.append("flag", "avatar");

      const response = await this.$ApiServiceLayer.post(
        "uploader",
        fd
      );

      if (response.status_code === 200) {
        this.$toast.open({
          message: 'عکس پروفایل شما با موفقیت ذخیره شد',
          type: 'success',
          // all of other options may go here
        });
         //this.avatarImage = response.url;
         this.getProfile();
      }

      if (response.status_code === 500) {
        this.$toast.open({
          message: 'تصویر انتخاب شده بیش از 80 کیلوبایت است',
          type: 'error',
          // all of other options may go here
        });
      }
    },
    getAvatarImage(){
      this.$refs.fileUpload.click();
    },
    onFilePicked (event) {
      const files = event.target.files
      //let filename = files[0].name
      const fileReader = new FileReader()
      fileReader.addEventListener('load', () => {
        this.imageUrl = fileReader.result
      })
      fileReader.readAsDataURL(files[0])
      this.avatarImage = files[0]
      if(this.avatarImage){
        this.updateAvatar();
        this.createImage(files[0]);
      }
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;

      reader.onload = (e) => {
        this.preAvatar = null;
        this.defaultimage = e.target.result;

        //this.$refs.profile_box.setAttribute("style",`background-image:url(${e.target.result})`);
        console.log(this.defaultimage);
        console.log(document.getElementById('profile_box'));

        //document.getElementById('profile_box').style.backgroundImage = "url("+this.defaultimage+")";

        document.getElementById('profile_box').setAttribute("style",`background-image:url(${e.target.result});background-size:contain`);

        this.getProfile();
      };
      reader.readAsDataURL(file);
    }
  },
};
</script>

<style scoped lang="scss">
.avatar-module {
  width: 100%;
  height: 100vh;
  background-color: #01bccb;
  padding-top: 42px;
  .avatar-container-box{
    height: 199px;
    width: 300px;
    background: #ffff;
    box-shadow: 2px 1px 11px 2px #80808066;
    border-radius: 20px;
    padding-top: 17px;
    .profile-pic {
      width: 120px;
      height: 120px;
      border-radius: 50%;
      border: 3px solid #000;
      background-color: #fff;
      box-shadow: 0px 0px 10px 4px #80808061;
    }
  }

  .background-image{
    width: 100%;
    height: 315px;
    background-image: url("~@/assets/img/bg/avatar.png");
    background-size: cover;
    background-position: center;
    position: absolute;
    bottom:0
  }
}
</style>
